export function Skeleton() {
  return (
    <div className="skeleton" aria-hidden="true">
      <span className="skeleton-line" />
      <span className="skeleton-line" />
      <span className="skeleton-line" />
    </div>
  );
}
